(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fr-launch-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseLaunch = value => {
      if (typeof value !== 'string') return null;
      const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
      if (!match) return null;
      const [, year, month, day, hour, minute, second = '0', offset] = match;
      const utc = new Date(Date.UTC(+year, +month - 1, +day));
      if (utc.getUTCFullYear() !== +year || utc.getUTCMonth() !== +month - 1 || utc.getUTCDate() !== +day || +hour > 23 || +minute > 59 || +second > 59) return null;
      if (offset !== 'Z' && (+offset.slice(1, 3) > 14 || +offset.slice(4, 6) > 59 || (+offset.slice(1, 3) === 14 && +offset.slice(4, 6) !== 0))) return null;
      const target = Date.parse(value.trim());
      return Number.isFinite(target) ? target : null;
    };

    const clockParts = (target, now) => {
      const total = Math.max(0, Math.ceil((target - now) / 1000));
      return { days: Math.floor(total / 86400), hours: Math.floor(total / 3600) % 24, minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
    };

    const createCountdownReflection = ({ root, target, reduced, listen, cleanup, isComplete }) => {
      const clock = root.querySelector('.fr-launch__clock');
      const button = root.querySelector('[data-countdown-motion]');
      const enabled = root.dataset.countdownReflection === 'true';
      const turnDuration = 1200;
      let phaseTimer;
      let paused = false;
      let inView = true;
      const between = (min, max) => min + Math.random() * (max - min);
      const inputFocused = () => root.contains(document.activeElement) && document.activeElement.matches('input,textarea,select');
      const allowed = () => enabled && !paused && !reduced.matches && !document.hidden && inView && root.isConnected && target !== null && Date.now() < target && !isComplete() && !inputFocused();
      const stop = () => {
        clearTimeout(phaseTimer);
        clock.classList.remove('is-mirror-back', 'is-reflecting');
        clock.dataset.reflectionPhase = 'idle';
      };
      const schedule = (first = false) => {
        stop();
        if (!allowed()) return;
        phaseTimer = window.setTimeout(reflect, first ? between(5500, 9500) : between(14000, 26000));
      };
      const reflect = () => {
        if (!allowed()) return stop();
        clock.classList.add('is-reflecting', 'is-mirror-back');
        clock.dataset.reflectionPhase = 'mirrored';
        phaseTimer = window.setTimeout(() => {
          clock.classList.remove('is-mirror-back');
          clock.dataset.reflectionPhase = 'returning';
          phaseTimer = window.setTimeout(schedule, turnDuration);
        }, turnDuration + between(1600, 2200));
      };
      const refresh = () => {
        button.hidden = !enabled || reduced.matches || target === null || isComplete();
        schedule();
      };
      if (enabled && target !== null && !reduced.matches && !isComplete()) button.hidden = false;
      listen(button, 'click', () => {
        paused = !paused;
        button.querySelector('[data-motion-label]').textContent = paused ? root.dataset.reflectionResume : root.dataset.reflectionPause;
        button.querySelector('[data-motion-icon]').textContent = paused ? '▷' : 'Ⅱ';
        schedule();
      });
      listen(reduced, 'change', refresh);
      listen(document, 'visibilitychange', () => { if (document.hidden) stop(); else schedule(); });
      listen(window, 'pagehide', stop);
      listen(window, 'pageshow', () => schedule(true));
      listen(root, 'focusin', event => { if (event.target.matches('input,textarea,select')) stop(); });
      listen(root, 'focusout', event => { if (event.target.matches('input,textarea,select')) queueMicrotask(() => schedule()); });
      if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(entries => {
          const visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
          if (visible === inView) return;
          inView = visible;
          if (inView) schedule(); else stop();
        }, { threshold: [0, .25] });
        observer.observe(clock);
        cleanup.push(() => observer.disconnect());
      }
      cleanup.push(stop);
      schedule(true);
      return { stop, finish: () => { stop(); button.hidden = true; } };
    };

    const init = root => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const cleanup = [];
      const listen = (node, event, handler, options) => {
        node.addEventListener(event, handler, options);
        cleanup.push(() => node.removeEventListener(event, handler, options));
      };
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
      const target = parseLaunch(root.dataset.launchAt);
      const dateLabel = root.querySelector('[data-launch-date]');
      const nodes = Object.fromEntries([...root.querySelectorAll('[data-count]')].map(node => [node.dataset.count, node]));
      const mirror = root.querySelector('[data-mirror-toggle]');
      const heading = root.querySelector('[data-launch-heading]');
      let timer;
      let completed = false;
      const reflection = createCountdownReflection({ root, target, reduced, listen, cleanup, isComplete: () => completed });

      const finish = () => {
        if (completed) return;
        completed = true;
        clearTimeout(timer);
        reflection.finish();
        dateLabel.textContent = root.dataset.dateFinished;
        root.querySelector('[data-launch-copy]').textContent = root.dataset.liveCopy;
        root.querySelector('.fr-launch__eyebrow').textContent = root.dataset.liveHeading;
        const enter = root.querySelector('[data-launch-enter]');
        if (enter) enter.hidden = false;
      };

      const tick = () => {
        clearTimeout(timer);
        if (target === null || document.hidden) return;
        const now = Date.now();
        const parts = clockParts(target, now);
        for (const [key, number] of Object.entries(parts)) {
          const node = nodes[key];
          const value = String(number).padStart(2, '0');
          if (node.textContent === value) continue;
          node.textContent = value;
          node.classList.remove('is-ticking');
          if (!reduced.matches) {
            void node.offsetWidth;
            node.classList.add('is-ticking');
          }
        }
        if (now >= target) finish();
        else timer = window.setTimeout(tick, Math.min(1000, target - now));
      };

      if (target !== null) {
        dateLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', { timeZone: root.dataset.timezone, month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date(target));
        tick();
      } else dateLabel.textContent = root.dataset.datePending;

      listen(document, 'visibilitychange', () => {
        clearTimeout(timer);
        if (!document.hidden && !completed) tick();
      });
      listen(window, 'pageshow', () => { if (!completed) tick(); });
      cleanup.push(() => clearTimeout(timer));
      mirror.hidden = false;
      listen(mirror, 'click', () => {
        const active = mirror.getAttribute('aria-pressed') !== 'true';
        mirror.setAttribute('aria-pressed', String(active));
        heading.classList.toggle('is-mirrored', active);
        mirror.querySelector('[data-mirror-label]').textContent = active ? root.dataset.mirrorOn : root.dataset.mirrorOff;
      });

      const cursor = root.querySelector('[data-launch-cursor]');
      let frame;
      let x = 0;
      let y = 0;
      let shownX = 0;
      let shownY = 0;
      let visible = false;
      const hideCursor = () => {
        visible = false;
        cursor.classList.remove('is-visible', 'is-pressed');
        cancelAnimationFrame(frame);
        frame = null;
      };
      const moveCursor = () => {
        shownX += (x - shownX) * .25;
        shownY += (y - shownY) * .25;
        cursor.style.transform = `translate(${shownX}px,${shownY}px) translate(-50%,-50%)`;
        if (visible && (Math.abs(x - shownX) > .1 || Math.abs(y - shownY) > .1)) frame = requestAnimationFrame(moveCursor);
        else frame = null;
      };
      listen(root, 'pointermove', event => {
        if (!fine.matches || reduced.matches || event.pointerType === 'touch') return hideCursor();
        x = event.clientX;
        y = event.clientY;
        if (!visible) { shownX = x; shownY = y; }
        visible = true;
        cursor.classList.add('is-visible');
        cursor.classList.toggle('is-hovering', Boolean(event.target.closest('a,button,input,summary')));
        if (!frame) frame = requestAnimationFrame(moveCursor);
      }, { passive: true });
      listen(root, 'pointerleave', hideCursor);
      listen(window, 'blur', hideCursor);
      listen(reduced, 'change', hideCursor);
      listen(fine, 'change', hideCursor);
      listen(root, 'pointerdown', () => { if (visible) cursor.classList.add('is-pressed'); });
      listen(window, 'pointerup', () => cursor.classList.remove('is-pressed'));
      cleanup.push(hideCursor);
      const section = root.closest('.shopify-section');
      if (section) listen(document, 'shopify:section:unload', event => {
        if (event.target === section) cleanup.forEach(dispose => dispose());
      });
      const errors = root.querySelector('#LaunchErrors');
      if (errors) errors.scrollIntoView({ block: 'center' });
      const passwordErrors = root.querySelector('#LaunchStoreAccess .fr-launch__error');
      if (passwordErrors) root.querySelector('.fr-launch__access').open = true;
    };

    const start = () => document.querySelectorAll('[data-fr-launch]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fr-roll-call"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fr-roll-call')) {
    customElements.define('fr-roll-call', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const panel = this.querySelector('[data-panel]');
        const open = this.querySelector('[data-open]');
        const close = this.querySelector('[data-close]');
        const form = this.querySelector('form');
        const result = this.querySelector('[data-result]');
        const viewport = this.querySelector('[data-viewport]');
        const track = this.querySelector('[data-track]');
        const group = this.querySelector('[data-group]');
        const pause = this.querySelector('[data-pause]');
        const message = this.querySelector('[data-message]');
        const handle = this.querySelector('[data-handle]');
        const post = this.querySelector('[data-post]');
        const prefersReduced = matchMedia('(prefers-reduced-motion: reduce)');
        const setOpen = (value) => { panel.hidden = !value; open.setAttribute('aria-expanded', String(value)); };
        setOpen(Boolean(result) || location.hash === '#' + form.id);
        close.hidden = false;
        open.addEventListener('click', (event) => {
          event.preventDefault();
          setOpen(true);
          (result || handle)?.focus({ preventScroll: true });
          panel.scrollIntoView({ behavior: 'auto', block: 'start' });
        }, options);
        close.addEventListener('click', () => { setOpen(false); open.focus(); }, options);
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { setOpen(false); open.focus(); }
        }, options);
        form.addEventListener('invalid', () => setOpen(true), { ...options, capture: true });
        if (result) { result.focus({ preventScroll: true }); panel.scrollIntoView({ block: 'start' }); }
        const count = () => {
          if (!message) return;
          if (message.value.length > message.maxLength) message.value = message.value.slice(0, message.maxLength);
          this.querySelector('[data-count]').textContent = String(message.value.length);
        };
        message?.addEventListener('input', count, options);
        count();
        handle?.addEventListener('blur', () => { handle.value = handle.value.trim().replace(/^@/, ''); }, options);
        const validatePost = () => {
          if (!post) return;
          post.setCustomValidity('');
          if (!post.value.trim()) return;
          try {
            const url = new URL(post.value.trim());
            if (url.protocol !== 'https:' || !['instagram.com', 'www.instagram.com'].includes(url.hostname) || url.username || url.password || url.port || !/^\/(p|reel|tv)\/[A-Za-z0-9_-]+\/?$/.test(url.pathname)) throw new Error('Invalid post');
          } catch (_) { post.setCustomValidity('Use a public Instagram post or Reel link, starting with https://www.instagram.com/p/ or /reel/.'); }
        };
        post?.addEventListener('input', validatePost, options);
        post?.addEventListener('blur', () => { post.value = post.value.trim(); validatePost(); }, options);
        form.addEventListener('submit', (event) => { validatePost(); if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); } }, options);
        if (!group) return;
        const setPaused = (value) => { this.dataset.paused = String(value); pause.textContent = value ? 'Resume' : 'Pause'; pause.setAttribute('aria-pressed', String(value)); };
        setPaused(false);
        pause.addEventListener('click', () => setPaused(this.dataset.paused !== 'true'), options);
        viewport.addEventListener('pointerdown', () => setPaused(true), options);
        viewport.addEventListener('focusin', (event) => {
          this.dataset.keyboard = 'true';
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, options);
        viewport.addEventListener('focusout', (event) => {
          if (!viewport.contains(event.relatedTarget)) { delete this.dataset.keyboard; viewport.scrollLeft = 0; }
        }, options);
        const measure = () => {
          if (!this.isConnected) return;
          const moving = !prefersReduced.matches && group.scrollWidth > viewport.clientWidth + 2;
          this.dataset.moving = String(moving);
          pause.hidden = !moving;
          const existing = track.querySelector('[data-clone]');
          if (moving && !existing) {
            const clone = group.cloneNode(true);
            clone.removeAttribute('data-group');
            clone.dataset.clone = '';
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
            clone.querySelectorAll('a').forEach((a) => a.tabIndex = -1);
            track.append(clone);
          } else if (!moving && existing) existing.remove();
          this.style.setProperty('--roll-distance', group.scrollWidth + 'px');
          this.style.setProperty('--roll-duration', Math.max(20, group.scrollWidth / (Number(this.dataset.speed) || 24)) + 's');
        };
        this.resizeObserver = new ResizeObserver(measure);
        this.resizeObserver.observe(group);
        this.resizeObserver.observe(viewport);
        prefersReduced.addEventListener('change', measure, options);
        document.fonts.ready.then(measure);
        measure();
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
 const init = () => {
  document.querySelectorAll('[data-fr-department]').forEach(item => {
   if (item.dataset.departmentBound) return;
   item.dataset.departmentBound = 'true';
   const desktop = () => item.closest('.fr-desktop-discovery') && matchMedia('(min-width:901px) and (hover:hover) and (pointer:fine)').matches;
   item.addEventListener('pointerenter', () => { if (desktop()) item.open = true; });
   item.addEventListener('pointerleave', () => { if (desktop() && !item.contains(document.activeElement)) item.open = false; });
   item.addEventListener('toggle', () => {
    if (item.open) item.parentElement.querySelectorAll('[data-fr-department]').forEach(other => { if (other !== item) other.open = false; });
   });
   item.addEventListener('keydown', event => {
    if (event.key === 'Escape' && item.open) { event.preventDefault(); event.stopPropagation(); item.open = false; item.querySelector('summary').focus(); }
   });
   item.addEventListener('focusout', () => { requestAnimationFrame(() => { if (!item.contains(document.activeElement) && !item.matches(':hover')) item.open = false; }); });
  });
 };
 document.addEventListener('click', event => { document.querySelectorAll('[data-fr-department][open]').forEach(item => { if (!item.contains(event.target)) item.open = false; }); });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
 document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const init = scope => {
    const shares = [...scope.querySelectorAll('[data-product-share]')];
    if (scope.matches?.('[data-product-share]')) shares.unshift(scope);
    shares.forEach(share => {
      if (share.dataset.shareReady === 'true') return;
      share.dataset.shareReady = 'true';
      const root = share.closest('[data-product-root]');
      const gallery = root?.querySelector('[data-apparel-gallery]');
      const form = document.getElementById(share.dataset.shareForm);
      const summary = share.querySelector('summary');
      const input = share.querySelector('[data-share-link]');
      const copy = share.querySelector('[data-share-copy]');
      const status = share.nextElementSibling;
      let busy = false;
      const valueOf = field => {
        if (!field || field.disabled || !field.value || field.selectedOptions?.[0]?.disabled) return '';
        return field.value;
      };
      const updateLink = () => {
        const url = new URL(share.dataset.shareUrl);
        url.search = ''; url.hash = '';
        const variantField = form?.elements.namedItem('id');
        const variant = valueOf(variantField);
        const validVariant = /^\d+$/.test(variant) && (variantField.options
          ? [...variantField.options].some(option => option.value === variant && !option.disabled)
          : variant === share.dataset.shareDefaultVariant);
        if (validVariant) url.searchParams.set('variant', variant);
        else ['color', 'size'].forEach(kind => {
          const value = valueOf(root?.querySelector('[data-product-option][data-option-kind="' + kind + '"]'));
          if (value) url.searchParams.set('fr_' + kind, value);
        });
        const view = gallery?.dataset.currentView || gallery?.querySelector('[data-apparel-frame]:not([hidden])')?.dataset.apparelView;
        if (['front', 'back', 'sleeve', 'detail'].includes(view)) url.searchParams.set('fr_view', view);
        if (gallery?.dataset.mirrorEnabled === 'true' && gallery.dataset.mirrored === 'true') url.searchParams.set('fr_mirror', '1');
        input.value = url.href;
        return url.href;
      };
      const manual = () => {
        share.open = true;
        status.textContent = share.dataset.shareManual;
        input.focus({ preventScroll: true }); input.select();
      };
      const copyLink = async url => {
        try {
          if (!navigator.clipboard?.writeText) { manual(); return; }
          await navigator.clipboard.writeText(url);
          status.textContent = share.dataset.shareCopied;
        } catch (_) { manual(); }
      };
      summary.addEventListener('click', async event => {
        if (share.open) return;
        event.preventDefault();
        if (busy) return;
        const url = updateLink();
        status.textContent = ''; busy = true;
        try {
          if (typeof navigator.share === 'function') {
            try { await navigator.share({ title: share.dataset.shareTitle, url }); }
            catch (error) { if (error?.name !== 'AbortError') await copyLink(url); }
          } else await copyLink(url);
        } finally { busy = false; }
      });
      copy.addEventListener('click', async () => {
        if (busy) return;
        const url = updateLink();
        status.textContent = ''; busy = true;
        try { await copyLink(url); } finally { busy = false; }
      });
      const refreshOpenLink = () => { if (share.open) updateLink(); };
      root?.addEventListener('change', refreshOpenLink);
      gallery?.addEventListener('fr:apparel-state', refreshOpenLink);
      window.addEventListener('popstate', refreshOpenLink);
      window.addEventListener('pageshow', refreshOpenLink);
      copy.hidden = false;
      updateLink();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
